// ----------------------------------------------------------------------------
// Component: Testimonial
// ----------------------------------------------------------------------------
//
// A list of testimonials
//
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_pull-quote.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--testimonials';
var CAROUSEL_CLASS = 'carousel--testimonials';
var CAROUSEL_SECTION_SELECTOR = '.carousel-section--testimonials';
var CAROUSEL_SECTION_CLASS = 'carousel-section--testimonials';
var CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
var CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

// -------------------------------------
// Helpers
// -------------------------------------

function handleTestimonialSlides(swiperEl) {
  if (!swiperEl.slides || !swiperEl.slides.length) return;
  swiperEl.slides.forEach(function (slide, index) {
    slide.addEventListener('focus', function () {
      var slidePos = swiperEl.$el[0].getBoundingClientRect();

      // Remove standard scrolling to element in focus due to it going off the screen (slides left when it needs to stay on screen)
      swiperEl.$el[0].scrollLeft = 0;
      swiperEl.slideTo(index);

      // Emulating normal tab focus due to needing to remove standard scroll
      // If element is already in viewport, do nothing
      // Otherwise, scroll to the element and it should be in the middle of the screen when scrolling stops
      if (!(slidePos.top >= 0 && slidePos.left >= 0 && slidePos.bottom <= window.innerHeight && slidePos.right <= window.innerWidth)) {
        window.scrollTo({
          top: slidePos.top + window.scrollY - window.innerHeight / 2,
          left: 0,
          behavior: 'smooth'
        });
      }
    });
  });
}
function initTestimonialCarousel(element, index) {
  var _element$querySelecto, _element$querySelecto2, _element$querySelecto3;
  var carouselEl = element.querySelector(CAROUSEL_SELECTOR);
  if (!carouselEl) return null;
  carouselEl.classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));
  (_element$querySelecto = element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR)) === null || _element$querySelecto === void 0 || _element$querySelecto.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index));
  (_element$querySelecto2 = element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR)) === null || _element$querySelecto2 === void 0 || _element$querySelecto2.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index));
  (_element$querySelecto3 = element.querySelector(CAROUSEL_PAGINATION_SELECTOR)) === null || _element$querySelecto3 === void 0 || _element$querySelecto3.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
    slidesPerView: 1,
    spaceBetween: 15,
    observer: true,
    observeParents: true,
    a11y: false,
    watchOverflow: true,
    navigation: {
      nextEl: ".".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index),
      prevEl: ".".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index)
    },
    pagination: {
      el: ".".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index),
      type: 'bullets',
      clickable: true
    }
  });
  handleTestimonialSlides(swiper);
  return swiper;
}

// -------------------------------------
// Hooks
// -------------------------------------
var testimonialInstances = new Map();
function mountTestimonialSections() {
  testimonialInstances.forEach(swiper => swiper.destroy());
  testimonialInstances.clear();
  document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
    var swiper = initTestimonialCarousel(element, index);
    if (swiper) testimonialInstances.set(element, swiper);
  });
}
mountTestimonialSections();
document.addEventListener('shopify:section:load', event => {
  if (event.target.matches(CAROUSEL_SECTION_SELECTOR)) {
    mountTestimonialSections();
  }
});